import { SurveyJSON } from "Survey/types"

const json: SurveyJSON = {
  success: 'Færdig!',
  allowNewCustomer: true,
  errors: {
    required: 'Udfyld venligst dette'
  },
  locales: {
    dk: {
      nextButton: 'Fortsæt',
      nextButtonHint: 'tryk <b>Enter ↵</b>',
      submitButton: 'Indsend',
      textAreaHint: '<b>Shift ⇧</b> + <b>Enter ↵</b> to make a line break',
      invalidEmail: "Email adressen er ugyldig"
    }
  },
  defaultLocale: 'dk',
  items: [
    {
      type: 'custom',
      name: 'header',
      html: 'Velkommen til Revisor1s Afstemningstest for afstemning af løn opgaver. Skriv dit svar under hvert spørgsmål. Når du er færdig, trykker du blot på ‘færdig’ knappen, og så modtager vi automatisk dine svar. God fornøjelse!',
      buttonsAlign: 'left',
      buttons: ['next']
    },
    {
      type: 'input',
      name: 'name',
      title: 'Hvad er dit navn',
      required: true,
      placeholder: 'Jens Jensen'
    },
    {
      type: 'input',
      inputType: 'email',
      name: 'email',
      title: 'Hvad er din email adresse?',
      required: true,
      placeholder: 'email@email.com'
    },
    {
      type: 'input',
      name: 'hvordan_checkes_om_Revisor1_har_adgang_til_kundens_eIndkomst',
      title: ' Hvordan checkes om Revisor1 har adgang til kundens eIndkomst',
      required: true,
      },
    {
type: 'input',
name: 'hvordan_haandteres_loenafstemning_hvis_Revisor1_ikke_er_autoriseret_til_kundens_eIndkomst',
title: ' Hvordan håndteres lønafstemning, hvis Revisor1 ikke er autoriseret til kundens eIndkomst',
required: true,
},
{
type: 'input',
name: 'hvad_er_formaalet_med_bogfoer_og_afstem_loen_med_eindkomst',
title: ' Hvad er formålet med “bogfør_og_afstem_løn_med_eindkomst”?',
required: true,
},
{
type: 'input',
name: 'hvor_gemmes_afstemningen_lavet_sheets',
title: ' Hvor gemmes afstemningen lavet sheets?',
required: true,
},
{
type: 'input',
name: 'hvilke_beloeb_skal_du_bogfoere_i_forbindelse_med_loenafstemning',
title: ' Hvilke beløb skal du bogføre i forbindelse med lønafstemning?',
required: true,
},
{
type: 'input',
name: 'hvordan_informerer_du_revisor_om_afstemningens_resultat',
title: ' Hvordan informerer du revisor om afstemningens resultat?',
required: true,
},
{
type: 'input',
name: 'hvilke_konti_skal_afstemmes_i_loen_afstemning',
title: ' Hvilke konti skal afstemmes i løn-afstemning?',
required: true,
},
{
type: 'input',
name: 'hvad_er_formaalet_med_tasken_bogfoer_og_afstem_loen_med_eindkomst',
title: ' Hvad er formålet med tasken “bogfør_og_afstem_løn_med_eindkomst”?',
required: true,
},
{
type: 'input',
name: 'giv_3_eksempler_paa_aarsager_til_at_loen_indberettet_ikke_stemmer_overens_med_bogfoert_loen_paa_konto_2210',
title: ' Giv 3 eksempler på årsager til at løn indberettet ikke stemmer overens med bogført løn på konto 2210.',
required: true,
},
{
type: 'input',
name: 'hvilket_udgangspunkt_tages_der_ved_bogfoering_af_loen_hos_Revisor1',
title: ' Hvilket udgangspunkt tages der, ved bogføring af løn hos Revisor1?',
required: true,
},
{
type: 'input',
name: 'skal_skyldige_loenposter_altid_tilbagefoeres_i_starten_af_ny_periode',
title: ' Skal skyldige lønposter altid tilbageføres i starten af ny periode?',
required: true,
},
{
type: 'input',
name: 'hvordan_identificerer_og_bogfoerer_du_skyldig_A_skat_og_AM_bidrag_ved_kvartalsafslutning',
title: ' Hvordan identificerer og bogfører du skyldig A-skat og AM-bidrag ved kvartalsafslutning?',
required: true,
},
{
type: 'input',
name: 'hvornar_skal_loenposter_foeres_som_mellemregning_i_stedet_for_loen',
title: ' Hvornår skal lønposter føres som mellemregning i stedet for løn?',
required: true,
},
{
type: 'input',
name: 'hvordan_sikrer_du_at_loenposteringer_ikke_paavirker_momsregnskabet_forkert',
title: ' Hvordan sikrer du, at lønposteringer ikke påvirker momsregnskabet forkert?',
required: true,
},
{
type: 'input',
name: 'hvad_er_forskellen_paa_brutto_og_netto_loen_paa_en_loensedel',
title: ' Hvad er forskellen på brutto- og nettoløn på en lønseddel?',
required: true,
},
{
type: 'input',
name: 'hvordan_haandteres_personalegoder_som_fri_telefon_fri_bil_eller_sundhedsordninger_i_bogfoeringen',
title: ' Hvordan håndteres personalegoder som fri telefon, fri bil eller sundhedsordninger i bogføringen?',
required: true,
},
{
type: 'input',
name: 'hvordan_haandterer_du_afvigelser_mellem_bogfoert_loen_og_eIndkomst',
title: ' Hvordan håndterer du afvigelser mellem bogført løn og eIndkomst?',
required: true,
},
{
type: 'input',
name: 'hvornar_skal_der_laves_hensaettelser_til_feriepenge_og_pension',
title: ' Hvornår skal der laves hensættelser til feriepenge og pension?',
required: true,
},
{
type: 'input',
name: 'hvor_findes_oplysninger_om_skyldige_feriepenge_og_pension',
title: ' Hvor findes oplysninger om skyldige feriepenge og pension?',
required: true,
},
{
type: 'input',
name: 'hvordan_haandteres_loenrefusioner_fra_kommunen_VEU_eller_barselsfonden',
title: ' Hvordan håndteres lønrefusioner fra kommunen, VEU eller barselsfonden? Svar: Bogføres særskilt (på 2240) og er ikke en del af lønafstemning mod eIndkomst.',
required: true,
},
{
type: 'input',
name: 'skal_loenrefusion_medtages_i_en_loenafstemning',
title: ' Skal lønrefusion medtages i en lønafstemning?',
required: true,
},
{
type: 'input',
name: 'hvad_er_ATP',
title: ' Hvad er ATP?',
required: true,
},
{
type: 'input',
name: 'skal_ATP_medtages_i_en_loenafstemning_mod_eIndkomst',
title: ' Skal ATP medtages i en lønafstemning mod eIndkomst?',
required: true,

 },
    {
      type: 'custom',
      name: 'submit',
      html: '<blockquote>Tryk "indsend" for at sende os svarene.</blockquote>',
      buttons: ['submit']
    }
  ]
}

export default json
